import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Link } from "../directives/link";
import { RouterLink } from "@angular/router";
import { TitleChange } from '../services/title-change';

@Component({
  selector: 'app-eusebius',
  imports: [Link, RouterLink],
  templateUrl: './eusebius.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './eusebius.scss',
})
export class Eusebius {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Eusebius`);
    this.dynamicTitle.description(`Eusebius admists to lying, interpolated into Josephus' works, and dated things ealier to benefit the church.`);
  }
}
